module.exports = __webpack_public_path__ + "media/payment_cash.edc02ff2.webm";